export enum PaymentStatus {
   WAITING_FOR_CONFIRMATION,
   SUCCESS,
   FAIL,
   TIMEOUT,
   CANCEL

}